import { render, staticRenderFns } from "./QueryExecutionResult.vue?vue&type=template&id=661ce6ec&"
import script from "./QueryExecutionResult.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QueryExecutionResult.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports